function normalizeInfiniteScrollPageParam() {
  const gridContainer = document.getElementById('ProductGridContainer');

  if (!gridContainer?.classList.contains('infinity-scroll-active')) {
    return;
  }

  const url = new URL(window.location.href);
  const page = parseInt(url.searchParams.get('page'), 10);

  if (!page || page <= 1) {
    return;
  }

  url.searchParams.delete('page');
  const normalizedUrl =
    url.pathname + (url.search ? url.search : '') + url.hash;

  history.replaceState({}, '', normalizedUrl);
}

class CollectionInfinityScroll {
  constructor() {
    this.gridContainer = document.getElementById('ProductGridContainer');
    this.intersectionObserver = null;
    this.mutationObserver = null;
    this.isLoading = false;
    this.loadMoreHost = null;
    this.btnLoadMore = null;
    this.onLoadComplete = this.onLoadComplete.bind(this);

    if (!this.gridContainer?.classList.contains('infinity-scroll-active')) {
      return;
    }

    normalizeInfiniteScrollPageParam();

    document.addEventListener(
      'collection:load-more:complete',
      this.onLoadComplete
    );

    this.init();
    this.observeGridChanges();
  }

  destroy() {
    this.disconnectIntersectionObserver();

    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }

    document.removeEventListener(
      'collection:load-more:complete',
      this.onLoadComplete
    );
  }

  init() {
    this.disconnectIntersectionObserver();

    this.loadMoreHost = document.querySelector(
      'collection-load-more[data-infinity-scroll]:not(.hidden)'
    );
    this.btnLoadMore = this.loadMoreHost?.querySelector('.js-btn-load-more');

    if (!this.loadMoreHost || !this.btnLoadMore?.dataset.href) {
      return;
    }

    this.intersectionObserver = new IntersectionObserver(
      entries => this.onIntersect(entries),
      { rootMargin: '200px 0px', threshold: 0 }
    );

    this.intersectionObserver.observe(this.loadMoreHost);
  }

  onIntersect(entries) {
    for (const entry of entries) {
      if (!entry.isIntersecting) {
        continue;
      }

      this.loadNext();
    }
  }

  loadNext() {
    if (this.isLoading) {
      return;
    }

    if (
      !this.loadMoreHost ||
      !this.btnLoadMore ||
      this.loadMoreHost.classList.contains('hidden') ||
      this.btnLoadMore.hasAttribute('disabled') ||
      !this.btnLoadMore.dataset.href
    ) {
      return;
    }

    this.isLoading = true;
    this.btnLoadMore.click();
  }

  onLoadComplete() {
    this.isLoading = false;

    const activeHost = document.querySelector(
      'collection-load-more[data-infinity-scroll]:not(.hidden)'
    );

    if (activeHost) {
      this.init();
      return;
    }

    this.disconnectIntersectionObserver();
  }

  disconnectIntersectionObserver() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }

  observeGridChanges() {
    if (!this.gridContainer) {
      return;
    }

    this.mutationObserver = new MutationObserver(() => {
      requestAnimationFrame(() => this.init());
    });

    this.mutationObserver.observe(this.gridContainer, {
      childList: true,
      subtree: true
    });
  }
}

function initCollectionInfinityScroll() {
  if (
    !document
      .getElementById('ProductGridContainer')
      ?.classList.contains('infinity-scroll-active')
  ) {
    return;
  }

  if (window.collectionInfinityScroll) {
    window.collectionInfinityScroll.destroy();
  }

  window.collectionInfinityScroll = new CollectionInfinityScroll();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionInfinityScroll);
} else {
  initCollectionInfinityScroll();
}

document.addEventListener('shopify:section:load', initCollectionInfinityScroll);
